import algoliasearch from 'algoliasearch'
import { createClient } from 'next-sanity'

import {
  apiVersion,
  dataset,
  projectId,
  searchApiKey,
  useCdn,
} from '../../sanity/env'

export const client = createClient({
  apiVersion,
  dataset,
  projectId,
  useCdn,
})

export const sanityFetch = client.fetch.bind(client)

export const searchClient = algoliasearch('2D9FJ53KV1', searchApiKey)
